export const LinkColor = {
  SECONDARY_CONTRAST: 'secondary_contrast',
  DARK: 'dark',
  LIGHT: 'light',
  MONO_900: 'mono_900'
};